var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPencilIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 6,
    fill: "#003E2C",
    fillOpacity: 0.0705882
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_658_690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.75 8.91599L17.0836 11.2493M18.3518 9.97319C18.6602 9.66486 18.8336 9.24664 18.8336 8.81054C18.8337 8.37444 18.6605 7.95618 18.3521 7.64777C18.0437 7.33936 17.6255 7.16607 17.1893 7.16602C16.7532 7.16596 16.3349 7.33915 16.0264 7.64748L8.24057 15.4343C8.10512 15.5693 8.00495 15.7356 7.94888 15.9184L7.17823 18.457C7.16315 18.5075 7.16201 18.5611 7.17493 18.6121C7.18785 18.6632 7.21435 18.7098 7.25162 18.747C7.28888 18.7842 7.33552 18.8106 7.38659 18.8234C7.43766 18.8363 7.49125 18.835 7.54168 18.8199L10.0812 18.0499C10.2639 17.9943 10.4301 17.8948 10.5654 17.76L18.3518 9.97319Z",
    stroke: "#026D4D",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_658_690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilIcon);
export default __webpack_public_path__ + "static/media/edit-pencil-icon.1d20367c454b16aaef1d4a7139c20d5a.svg";
export { ForwardRef as ReactComponent };